const STREAMING_UNIT = {
  Gbps: 'Gbps',
  Mbps: 'Mbps',
  Kbps: 'Kbps',
};
const BPS_PER_KBPS: number = 1_000; // 1 thousand
const BPS_PER_MBPS: number = BPS_PER_KBPS * 1_000; // 1 million
const BPS_PER_GBPS: number = BPS_PER_MBPS * 1_000; // 1 billion

/**
 * Formats bandwidth value in bits per second (bps) to a human-readable string
 * with appropriate decimal units (Kbps, Mbps, Gbps)
 *
 * @param bps Bandwidth in bits per second
 * @param decimalPoints Number of decimal points to display
 * @param locale The locale to use for number formatting (defaults to 'en-US')
 * @returns Formatted bandwidth string with appropriate unit
 */

export const formatBandwidth = (
  bps: number,
  decimalPoints: number,
  locale: string = 'en-US',
): string => {
  const formatOptions: Intl.NumberFormatOptions = {
    minimumFractionDigits: decimalPoints,
    maximumFractionDigits: decimalPoints,
  };

  let value: number;
  let unit: string;

  if (bps >= BPS_PER_GBPS) {
    value = bps / BPS_PER_GBPS;
    unit = STREAMING_UNIT.Gbps;
  } else if (bps >= BPS_PER_MBPS) {
    value = bps / BPS_PER_MBPS;
    unit = STREAMING_UNIT.Mbps;
  } else {
    value = bps / BPS_PER_KBPS;
    unit = STREAMING_UNIT.Kbps;
  }

  try {
    return new Intl.NumberFormat(locale, formatOptions).format(value) + ' ' + unit;
  } catch (error) {
    return new Intl.NumberFormat('en-US', formatOptions).format(value) + ' ' + unit;
  }
};
